const handleEscapeClose = () => {
    const escapeHandler = (event) => {
        if (event.key === 'Escape') {
            const backdrop = document.querySelector('.backdrop');
            const showSubmenuTriggers = document.querySelectorAll('.wiacc-show-submenu');
            const productSearchItem = document.querySelectorAll('.search-item');

            if (backdrop) {
                backdrop.click();
                enableScroll();
                showSubmenuTriggers.forEach(trigger => {
                    trigger.setAttribute('aria-expanded', 'false');
                });

                productSearchItem.forEach(trigger => {
                    trigger.setAttribute('aria-selected', 'false');
                });
            }
        }
    };

    document.addEventListener('keydown', escapeHandler);

    return () => {
        document.removeEventListener('keydown', escapeHandler);
    };
};